import React from "react";

/**
 * Grayscale/white client logo strip — looped marquee.
 */
export const LogoStrip = ({ logos = [], className = "" }) => {
  // Duplicate for seamless loop
  const loop = [...logos, ...logos];
  return (
    <div
      className={`marquee-mask w-full overflow-hidden ${className}`}
      data-testid="logo-strip"
    >
      <div
        className="flex items-center gap-12 md:gap-16 animate-ticker"
        style={{ width: "max-content" }}
      >
        {loop.map((l, i) => (
          <img
            key={i}
            src={l.src}
            alt={l.alt}
            loading="lazy"
            className="h-8 md:h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        ))}
      </div>
    </div>
  );
};

export default LogoStrip;
